/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var OloReportType;
(function (OloReportType) {
    OloReportType["ITEMIZED_ORDERS"] = "itemized_orders";
    OloReportType["ITEMIZED_ADJUSTED_ORDERS"] = "itemized_adjusted_orders";
    OloReportType["ITEMIZED_CANCELLED_ORDERS"] = "itemized_cancelled_orders";
    OloReportType["COUPON_REDEMPTIONS"] = "coupon_redemptions";
    OloReportType["LOYALTY_REWARD_REDEMPTIONS"] = "loyalty_reward_redemptions";
    OloReportType["DISPATCH_DELIVERIES"] = "dispatch_deliveries";
})(OloReportType || (OloReportType = {}));
